import { RadioButton } from "plos/src/components/forms/RadioButton";
import { RadioButtonGroup } from "plos/src/components/forms/ReactHookFormControlled/RadioButtonGroup";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TeamBuilderPreferencesFormData } from "../../../types";
import { getPositionFocusChoices } from "../../../utils";
import { stepContainer } from "../../teamBuilder.css";

const PositionFocusForm = () => {
  const { control } = useFormContext<TeamBuilderPreferencesFormData>();
  const { t } = useTranslation("onboarding");
  const positionFocusChoices = getPositionFocusChoices(t);

  return (
    <div className={stepContainer}>
      <RadioButtonGroup
        control={control}
        name="positionFocus"
        rules={{ required: true }}
        id="positionFocus"
        label={t(
          "positionFocusLabel",
          "Your squad scores points in defence and attack. Do you want to focus your budget, or keep it balanced?",
        )}
        hideLabel
      >
        {positionFocusChoices.map(({ value, label, extendedLabel }) => (
          <RadioButton
            key={value}
            value={value}
            autoFocus={value === "balanced_squad"}
            fontWeight="regular"
            description={extendedLabel}
          >
            {label}
          </RadioButton>
        ))}
      </RadioButtonGroup>
    </div>
  );
};

export default PositionFocusForm;
